import React from "react";
import logoConfimea from "../../images/confimea-imprese.png";
import localeText from "../../../locale";

const ConfimeaPartnership = () => {
  return (
    <section className="confimea-partnership-section">
      <div className="confimea-container">
        <div className="confimea-partnership-inner">
          <div className="confimea-partnership-text text-center md:text-left">
            <div className="flex flex-column md:flex-row gap-4 align-items-center mb-4">
              <span className="confimea-partnership-badge">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  width="36"
                  height="36"
                >
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </span>
              <hr
                style={{ width: "2px", height: "48px", background: "#E5E7EB" }}
                className="opacity-20 hidden md:block"
              />
              <div className="confimea-partnership-title title">
                {localeText("partnershipTitle")}
              </div>
            </div>

            <p className="confimea-partnership-subtitle">{localeText("partnershipSubtitle")}</p>
            <div className="confimea-partnership-links flex flex-column md:flex-row align-items-center md:align-items-start">
              <div className="flex align-items-center gap-2">
                <i className="pi pi-check-circle" style={{ color: "rgba(126, 229, 192, 1)" }}></i>
                <div className="text-white">Verificato e certificato</div>
              </div>
              <div className="flex align-items-center gap-2">
                <i className="pi pi-check-circle" style={{ color: "rgba(126, 229, 192, 1)" }}></i>
                <div className="text-white">Supporto dedicato</div>
              </div>
            </div>
          </div>

          <div className="confimea-partnership-logos">
            <div className="confimea-partnership-logo w-full">
              <img src={logoConfimea} alt="Confimea Imprese" />
            </div>
            {/* <div className="confimea-partnership-plus">+</div>
            <div className="confimea-partnership-logo w-full">
              <img src={logoExtraconomy} alt="Extraconomy" />
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConfimeaPartnership;
